import React, { forwardRef, Fragment } from 'react';
import Table from 'react-bootstrap/Table';

const PrintableBackOrders = forwardRef(({ backorderItems, currentPage, pageResults }, ref) => {

    return (
        <div className="print-container" ref={ref}>

            <h2 className="text-center mb-3">BACK ORDERS</h2>

            <div className="table-legend table-legend-sm mb-3 text-center">
                <span className="icons-row"><div className={`status-icon red-icon`} title="Purchase order has been submitted to supplier"></div> On Order</span>
                <span className="svg-holder">
                    <img src="../../../Images/red-striped.svg" alt="red striped icon" title="Purchase order has been submitted to supplier but has not been fulfilled yet" className="mr-1" />
                    On Order Past Due
                </span>
                <span className="icons-row"><div className={`status-icon yellow-icon`} title="Shipment is in transit and on time"></div> In Transit to KMC</span>
                <span className="svg-holder">
                    <img src="../../../Images/yellow-striped.svg" alt="yellow striped icon" title="Shipment is in transit but experiencing a delay" className="mr-1" />
                    In Transit to KMC - Past Due
                </span>
                <span className="svg-holder">
                    <img src="../../../Images/green-striped.svg" alt="green striped icon" title="Incoming shipment has arrived at KMC warehouse" className="mr-1" />
                    Dock Arrival
                </span>
                <span className="icons-row"><div className={`status-icon green-icon`} title="Parts have arrived at KMC and will allocate soon"></div> Available</span>
            </div>

            <div className="order-table">
                <Table className="compact-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>ITEM # & <br />DESCRIPTION</th>
                            <th>ORDER <br /> ID</th>
                            <th>ORDER <br /> TYPE</th>
                            <th>MEMO</th>
                            <th>AVAILABILITY <br /> STATUS</th>
                            <th>EST. SHIP <br /> DATE</th>
                            <th>CANCEL <br /> DATE</th>
                            <th>PACKAGE <br /> QTY</th>
                            <th>BKORD <br /> QTY</th>
                            <th>SHIPPING <br /> METHOD</th>
                        </tr>
                    </thead>
                    <tbody>
                        {backorderItems && backorderItems.map((item, index) => (
                            <tr className="" key={item.orderNbr + item.itemNbr}>
                                <td>{(currentPage * pageResults) + index + 1}</td>
                                <td><span className="bold">{item.itemNbr}</span> <br /> {item.itemDesc}</td>
                                <td>{item.orderNbr}</td>
                                <td>{item.orderType}</td>
                                <td>{item.memo}</td>
                                <td className="table-legend-sm text-center">
                                    {item.imgSource === '' ?
                                        <span className="icons-row">
                                            <div className={item.className} title={item.title}></div>
                                        </span>
                                        : item.imgSource && item.imgAlt &&
                                        <span className="svg-holder">
                                            <img src={item.imgSource} alt={item.imgAlt} title={item.title} />
                                        </span>
                                    }
                                </td>
                                <td>{item.estimatedShipDate}</td>
                                <td>{item.cancelDate}</td>
                                <td>{item.pkgQty}</td>
                                <td>
                                    {item.bOQty}
                                </td>
                                <td>{item.shipInstructions}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </div>
    )
});

export default PrintableBackOrders;